import '../styles/style.css';

function HomePage() {
  return (
    <div className="root">
      <header className="header">
        <div className="container">
          <div className="header-content">
            <a href="#" className="logo">
              <img src="/img/logo.jpg" alt="हिसाब OK" style={{ height: '36px', width: 'auto', display: 'block' }} />
            </a>
          </div>
        </div>
      </header>
      <main>
        <section className="hero">
          <div className="container hero-flex">
            <div className="hero-content">
              <h1>रेंट हो या ट्यूशन फीस, अब हिसाब होगा चुटकियों में!</h1>
              <p>हिसाब OK आपके PG व ट्यूशन बिजनेस के लिए एक आसान और स्मार्ट मोबाइल ऐप है। रेंट ट्रैकिंग, पेमेंट रिमाइंडर, और ऑटोमेटेड हिसाब-किताब के साथ अपना काम आसान बनाएं।</p>

              <a href="#" className="cta-button">मोबाइल ऐप जल्द आ रहा है</a>
            </div>
            <div className="hero-image-box">
              <img src="/img/graphics-vendor01.jpg" alt="Vendor Graphic" className="hero-image" />
            </div>
          </div>
        </section>
        <section className="features">
          <div className="container">
            <h2>मुख्य फीचर्स</h2>
            <div className="features-list">
              <div className="feature-row">
                <div className="feature-item feature-item-clean">
                  <h3>आसान रेंट साइकल मैनेजमेंट</h3>
                  <p>अब रजिस्टर लेकर बैठने या हिसाब जोड़ने की ज़रूरत नहीं। आपका सारा डेटा ऐप में सुरक्षित है और कैलकुलेशन अपने आप हो जाती है। रूम वाइज ट्रैकिंग और पेमेंट साइकल आसानी से मैनेज करें।</p>
                </div>
                <div className="feature-image-box feature-image-box-clean">
                  <img src="/img/graphics-feature02.jpg" alt="Easy Tracking and Auto Cycles" className="feature-image feature-image-clean" />
                </div>
                
              </div>
              <div className="feature-row feature-row-reverse">
                <div className="feature-item feature-item-clean">
                  <h3>पैसे माँगने की झिझक खत्म, अब हिसाब और रिमाइंडर दोनों होंगे ऑटोमैटिक।</h3>
                  <p>देर न हो, पेमेंट्स टाइम पर आएं। ऐप खुद रिमाइंडर भेजेगा और कलेक्शन 3x तेज होगा।</p>
                </div>
                <div className="feature-image-box feature-image-box-clean">
                  <img src="/img/graphics-feature01.jpg" alt="Timely Reminders Graphic" className="feature-image feature-image-clean" />
                </div>
              </div>
              <div className="feature-row">
                <div className="feature-item feature-item-clean">
                  <h3>PG रेंट या ट्यूशन फीस के लिए स्मार्ट ऑल-इन-वन सॉल्यूशन</h3>
                  <p>स्टूडेंट्स और किरायदारों से मंथली पेमेंट्स आसानी से रिसीव करें। किसने पैसे दिए और किसका बकाया है, यह जानने के लिए पन्ने पलटने की ज़रूरत नहीं। बस एक क्लिक करें और पूरे महीने का हिसाब अपनी आँखों के सामने पाएँ।</p>
                </div>
                <div className="feature-image-box feature-image-box-clean">
                  <img src="/img/graphics-vendor03.jpg" alt="Smart All-in-One Solution" className="feature-image feature-image-clean" />
                </div>
                
              </div>
            </div>
          </div>
        </section>
        {/* <section className="screenshots">
          <div className="container">
            <h2>ऐप स्क्रीनशॉट्स</h2>
            <div className="screenshots-grid">
              <div className="screenshot-placeholder">कस्टमर्स हिसाब स्क्रीन<br/>(यहाँ ऐप का हिसाब डैशबोर्ड SVG/इमेज लगाएं)</div>
              <div className="screenshot-placeholder">सभी कस्टमर्स स्क्रीन<br/>(यहाँ सभी यूजर्स लिस्ट SVG/इमेज लगाएं)</div>
            </div>
          </div>
        </section> */}
        <section className="contact">
          <div className="container">
            <h2>संपर्क करें</h2>
            <p>कुछ पूछना हो या फीडबैक दें? हमें ईमेल करें।</p>
            <p>ईमेल: info@hisabok.com</p>
            <p className="address">पता: Awfis Majestic Signia, 1st Floor, Plot No. A-27, Sector 62, Noida, UP - 201309</p>
            <p>PG और ट्यूशन कम्युनिटी के लिए बनाया गया।</p>
            <div className="copyright-contact">
              <p>&copy; 2025 Hisab OK. सभी अधिकार सुरक्षित।</p>
            </div>
          </div>
        </section>
      </main>
      <div className="fixed-bar">
        <span className="fixed-bar-text">अब होगा हिसाब बराबर ...</span>
        <span className="arrow-animate">
          <svg
            className="arrow-svg"
            width="48" height="48" viewBox="0 0 48 48"
            style={{ display: 'block', margin: '0 auto' }}
          >
            <g>
              <line x1="24" y1="12" x2="24" y2="36" stroke="#5a6473" strokeWidth="4" strokeLinecap="round" />
              <polyline points="16,28 24,36 32,28" fill="none" stroke="#5a6473" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            </g>
          </svg>
        </span>
        {process.env.ENABLE_APP_REDIRECT === 'true' ? (
          <a
            href="#"
            className="login-button"
            style={{ textDecoration: 'none' }}
            onClick={e => {
              e.preventDefault();
              const envUrl = process.env.REACT_APP_URL;
              if (envUrl) {
                window.location.href = envUrl;
              } else {
                // Get current root domain (including subdomain)
                const { hostname } = window.location;
                // Remove www. if present
                const root = hostname.replace(/^www\./, '');
                window.location.href = `https://app-${root}`;
              }
            }}
          >
            लॉगिन करें
          </a>
        ) : (
          <a
            href="#"
            className="login-button"
            style={{ textDecoration: 'none', pointerEvents: 'none', opacity: 0.6, cursor: 'not-allowed' }}
            tabIndex={-1}
            aria-disabled="true"
          >
            जल्द आ रहा है
          </a>
        )}
      </div>
      <div className="fixed-bar-spacer"></div>
    </div>
  );
}

export default HomePage;